import { useCallback } from 'react';
import { staffRoute } from '../../helpers/apiRoutes';
import { useApiCalls } from '../UseApiCalls';
import { INewClocking } from '../../interfaces/StaffClocking/INewClocking';

export const StaffApis = () => {
  const { getQuery, postQuery } = useApiCalls();

  const getDepartments = useCallback(() => {
    return getQuery(`${staffRoute}/get-departments`);
  }, [getQuery]);

  const getOffices = useCallback(() => {
    return getQuery(`${staffRoute}/get-offices`);
  }, [getQuery]);

  const getEmployeeDetails = useCallback(
    (referenceNumber: string) => {
      return getQuery(`${staffRoute}/get-employee-details/${referenceNumber}`);
    },
    [getQuery]
  );

  const postNewClocking = useCallback(
    (clockingData: INewClocking) => {
      return postQuery(`${staffRoute}/new-clocking`, clockingData);
    },
    [postQuery]
  );

  return { getDepartments, getOffices, getEmployeeDetails, postNewClocking };
};
